import { isEmpty } from "lodash";
import fetchJSON from "./utils/fetchJSON";

let isRefreshing = false;
let refreshSubscribers = [];

const TOKEN_ENDPOINT = "/oauth/token";
const TOKEN_STORAGE_KEY = "token";
export const REFRESH_AT = 60 * 15 * 1000;

export async function getAccessToken(username, password) {
  try {
    const token = await fetchJSON(TOKEN_ENDPOINT, {
      method: "POST",
      body: {
        grant_type: "password",
        username: username,
        password: password
      }
    });
    return setToken(token);
  } catch (err) {
    setToken(null);
    throw err;
  }
}

export async function refreshAccessToken(refreshToken) {
  try {
    const token = await fetchJSON(TOKEN_ENDPOINT, {
      method: "POST",
      body: {
        grant_type: "refresh_token",
        refresh_token: refreshToken
      }
    });
    return setToken(token);
  } catch (err) {
    setToken(null);
    throw err;
  }
}

export function setToken(token) {
  if (!token || isEmpty(token)) {
    localStorage.removeItem(TOKEN_STORAGE_KEY);
    return;
  }

  const storedToken = {
    ...token,
    expires_at: Date.now() + token.expires_in * 1000
  };
  localStorage.setItem(TOKEN_STORAGE_KEY, JSON.stringify(storedToken));
  return storedToken;
}

export function getToken() {
  try {
    return JSON.parse(localStorage.getItem(TOKEN_STORAGE_KEY));
  } catch (e) {
    return {};
  }
}

export async function ensureAccessToken() {
  const { access_token, refresh_token, expires_at } = getToken() || {};

  if (+new Date() + REFRESH_AT > expires_at) {
    if (!isRefreshing) {
      isRefreshing = true;
      refreshAccessToken(refresh_token).then(token => {
        isRefreshing = false;
        if (token) onRefreshed(token.access_token);
      });
    }

    return new Promise(resolve => subscribeTokenRefresh(resolve));
  } else {
    return access_token;
  }
}

export function withAccessToken(cb) {
  const { access_token, refresh_token, expires_at } = getToken() || {};

  if (+new Date() + REFRESH_AT > expires_at) {
    if (!isRefreshing) {
      isRefreshing = true;
      refreshAccessToken(refresh_token).then(token => {
        isRefreshing = false;
        if (token) onRefreshed(token.access_token);
      });
    }

    subscribeTokenRefresh(cb);
  } else {
    return cb(access_token);
  }
}

function subscribeTokenRefresh(cb) {
  refreshSubscribers.push(cb);
}

function onRefreshed(token) {
  refreshSubscribers.forEach(cb => cb(token));
  refreshSubscribers = [];
}

export function authFetch(uri, options = {}) {
  if (!options.headers) {
    options.headers = {};
  }

  return withAccessToken(accessToken => {
    options.headers["Authorization"] = accessToken
      ? `Bearer ${accessToken}`
      : null;
    return fetch(uri, options);
  });
}



// WEBPACK FOOTER //
// ./src/auth.js